<template>
    <div class="sub-record-list">
        <div class="sub-record-opration">

            <div style="display: inline-block;margin-right: 50px">
                <span>订阅状态:</span>
                <el-select v-model="queryParams.subStatus" placeholder="类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="订阅中" :value="1"></el-option>
                    <el-option label="过期" :value="2"></el-option>
                </el-select>
            </div>
            <el-select v-model="queryParams.type" placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-input placeholder="请输入内容" clearable v-model="queryParams.typeValue" style="width: 350px">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button style="margin-left: 10px" type="danger" @click="searchSubRecord">搜索</el-button>

        </div>
        <div class="sub-record-list">
            <el-table class="sub-record-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column prop="id" label="记录ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="strategyId" label="策略ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="userId" label="订阅用户id" show-overflow-tooltip></el-table-column>
                <el-table-column prop="strategyName" label="策略名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="strategyProviderMerchantName" label="策略提供商"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="subBuyType" label="订阅套餐" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.subBuyType == 1">1个月</span>
                        <span v-if="scope.row.subBuyType == 2">3个月</span>
                        <span v-if="scope.row.subBuyType == 3">连续包月</span>
                    </template>
                </el-table-column>
                <el-table-column prop="subStatus" label="订阅状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.subStatus == 1">订阅中</span>
                        <span v-if="scope.row.subStatus == 2">过期</span>
                    </template>
                </el-table-column>
                <el-table-column label="到期时间" width="200">
                    <template slot-scope="scope">
                        <span>{{scope.row.expireDate | moment}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: "SubManage",
        data() {
            return {
                dataList: [], //数据列表
                total: 0, //总条数
                queryParams: { //查询参数
                    type: 0,
                    typeValue: "",
                    userId: "",
                    strategyName: "",
                    subStatus: "",
                    page: 1,
                    size: 10
                },
                typeList: [
                    {label: '策略名称', value: 0},
                    {label: '订阅用户ID', value: 1},
                ],
            }
        },
        computed: {},
        mounted() {
        },
        methods: {
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getSubRecordPage(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getSubRecordPage(this.queryParams);
            },
            getSubRecordPage(param) {
                if(this.queryParams.type==0){
                    this.queryParams.userId = "";
                    this.queryParams.strategyName = this.queryParams.typeValue;
                }else if(this.queryParams.type==1){
                    this.queryParams.userId = this.queryParams.typeValue;
                    this.queryParams.strategyName = "";
                }else {
                    this.queryParams.userId = "";
                    this.queryParams.strategyName = "";
                }
                api.getSubRecordPage(param).then(({data}) => {
                    this.dataList = data.data;
                    this.total = data.total;
                });
            },
            searchSubRecord() {
                this.queryParams.page = 1;
                this.getSubRecordPage(this.queryParams);
            }
        },
        created() {
            this.getSubRecordPage(this.queryParams);
        }
    }
</script>


<style type="text/css">
    .sub-record-list .el-tabs__nav-wrap::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: rgba(245, 249, 255, 0);
        z-index: 1;
    }
</style>
<style lang="less" scoped>
    .sub-record-list {

        .sub-record-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .sub-record-table {
                margin-top: 30px;

                .red {
                    color: #EC6D56;
                }
                .blue {
                    color: #406CE9;
                }
                .green {
                    color: #6dec82;
                }
            }
        }
    }
</style>